<template>
    <div v-on:keyup.esc="$root.$emit('CLOSESOURCEDIALOG')" class="dialog draggable-item bg-light light w-100-sm w-100-md w-75-lg  w-50-xl h-75">

        <DialogTitle :title="$t('Configure Backup Source')" :defaultTitle="$t('Configure Backup Source')" :subTitle="source.type_name" @closeDialog="$root.$emit('CLOSESOURCEDIALOG')" />

        <!--SCELTA PERCORSI-->
        <div v-if="step == STEP_SA_AND_SOURCE" class="dialog-content bg-light">
            <!------------------------------SCELTA DEL SERVICE ACCOUNT--------------------------------------------------------------->

            <!--Questa pagina deve implementare il metodo "sendSATestResult"-->
            <SARepoSelect :type=source.type :idSA=source.id_service_account :idRepo="-2" @sendSATestResult="sendSATestResult" />

            <SelectedResourcesLayout buttonText="Select files and folders" :singleItem="false" :type="source.type" :isDisabled="!testResult.ok" :list="source.networkSource.paths" :heightPercentage="30" :canCancel="true" @clickFunction="toggleFileSystemSidebar" />
            <div class="d-flex flex-column form-group h-20 mt-auto">
                <!--Opzione abilitata prossimamente-->
                <!--input type="checkbox" v-model="source.options.copySecurityPermissions" data-role="checkbox"
                    :data-caption="$t('Copy security permissions')" :disabled="!testResult.ok" /-->
                <input type="checkbox" v-model="source.options.recreateCompletePath" data-role="checkbox" :data-caption="$t('Recreate the full path of the items')" :disabled="!testResult.ok" />
            </div>
        </div>


        <!--FILTRI-->
        <div class="dialog-content overflow bg-light" v-if="step == STEP_FILTERS">

            <BackupSteps :extensionsFilter="true" :fileSizeFilter="true" :exclusions="false" :type="$ONEServiceType.Network" :client="testResult.client" key="filters" @sendOptions="(options) => source.options = options" :mainNodes="source.networkSource.paths" :options="source.options" />

        </div>

        <!--ESCLUSIONI-->
        <div class="dialog-content bg-light overflow" v-if="step == STEP_EXCLUSIONS">
            <BackupSteps :extensionsFilter="false" :fileSizeFilter="false" :exclusions="true" @sendOptions="(options) => source.options = options" :mainNodes="source.networkSource.paths" :options="source.options" :type="$ONEServiceType.Network" :client="testResult.client" key="exclusions" />

        </div>

        <!--BACKUP-->
        <div class="dialog-content bg-light" v-show="step == STEP_BACKUPTYPE">
            <div class="form-group">
                <label class="text-bold">
                    <span>{{ $t('Backup mode') }}</span>
                </label>
            </div>
            <div class="form-group">
                <label>{{ $t("Type") }}:</label>
                <select v-model="source.options.backupType" data-role="select" class="input mb-6" data-filter="false">
                    <option v-for="key in Object.keys($root.selectValues.backupTypes)" :value="key" v-bind:key="key">{{
                        $t($root.selectValues.backupTypes[key]) }}</option>
                </select>
            </div>

            <div class="form-group">
                <label>{{ $t("Number of copies") }}:</label>
                <input type="number" v-number v-range="{ min: 1, max: 365 }" class="input" v-model.number="source.options.nCopies" />
            </div>

            <div class="form-group">
                <label>{{ $t("Number of parallel threads") }}:</label>
                <input type="number" v-range="{ min: 1, max: 10 }" v-number v-model.number="source.options.nThreads" class="w-10 input" />
                <label class="text-muted">{{ $t("Range: {0}-{1}", { '0': 1, '1': 10 }) }}</label>

            </div>
        </div>

        <!--COMPRESSIONE ZIP-->
        <div class="dialog-content bg-light" v-if="step == STEP_COMPRESSION" :disabled="source.options.backupType == 'U'">
            <BackupSteps :zipCompression="true" key="zipCompression" @sendOptions="(options) => source.options = options" :options="source.options" />
        </div>
        <div class="dialog-actions">
            <div v-if="nextButtonDisabled_message != ''" class="mr-auto w-50 p-0 fg-cobalt" :title="nextButtonDisabled_message">
                <pre class="text-small text-truncate">{{ nextButtonDisabled_message }}</pre>
            </div>

            <button v-on:click="setStep(step - 1)" class="button secondary" :disabled="step == 0"><span class="mif-arrow-left mr-2"> </span> {{ $t('Back') }}</button>
            <button v-on:click="setStep(step + 1)" class="button secondary" :disabled="!enableNextButton">{{ $t('Next') }} <span class="mif-arrow-right ml-2"> </span></button>
            <button v-on:click="saveSource" class="button secondary" :disabled="!enableSaveButton">{{ $t('Save') }} </button>
            <button class="button secondary" @click="$root.$emit('CLOSESOURCEDIALOG')">{{ $t("Close") }}</button>
        </div>
    </div>
</template>
<script>
import DialogTitle from "../../utils/DialogTitle";
import SARepoSelect from "../../utils/SARepoSelect";
import NoDataAvailable from "../../utils/NoDataAvailable.vue";
import SelectedResourcesLayout from "../../utils/SelectedResourcesLayout.vue"
import { isValid } from "../../../utils/utilitiesmodule";
import { draggableMixin } from '../../../mixins/draggable-mixin'
import BackupSteps from "../../utils/BackupSteps.vue";
import { FileSystemSidebarConfig } from "../../../models/TreeNode";
import { disconnectServiceAccount, testServiceAccount } from "../../../utils/entityMethods/serviceAccount";

export default {
    mixins: [draggableMixin],
    name: "NetworkSource",
    props: {
        source: Object,
    },
    components: {
        "DialogTitle": DialogTitle,
        "NoDataAvailable": NoDataAvailable,
        SARepoSelect,
        SelectedResourcesLayout,
        BackupSteps
    },
    data() {
        return {
            step: 0,
            testResult: {
                ok: false,
                okNumber: 0,
                serviceAccount: { id: -2, type: this.$ONEServiceType.Network },
                client: null,// il client della piattaforma che effettuerà le richieste dei list
                list: null,
            },
            STEP_SA_AND_SOURCE: 0,
            STEP_FILTERS: 1,
            STEP_EXCLUSIONS: 2,
            STEP_BACKUPTYPE: 3,
            STEP_COMPRESSION: 4,
            nextButtonDisabled_message: ""
        }
    },
    computed: {
        enableNextButton() {
            //Se la modalità di backup è update full, non permetto di configurare la compressione zip
            if (this.step == this.STEP_COMPRESSION || (this.step == this.STEP_BACKUPTYPE && this.source.options.backupType == 'U')) {
                //this.nextButtonDisabled_message="In the selected backup mode, ZIP compression isn't available because archives cannot be updated with new files.";
                this.nextButtonDisabled_message = "";
                return false;
            }

            if (this.step == this.STEP_SA_AND_SOURCE && this.source.networkSource.paths.length == 0) {
                if (this.testResult.ok)
                    this.nextButtonDisabled_message = this.$t('Select at least one item to include in the backup');
                else
                    this.nextButtonDisabled_message = this.$t("Select and validate a service account");
                return false;
            }

            this.nextButtonDisabled_message = "";

            return true;
        },
        enableSaveButton() {
            return this.step == this.STEP_COMPRESSION || (this.step == this.STEP_BACKUPTYPE && this.source.options.backupType == 'U');
        },
    },


    created: function () {
        this.$root.$emit('closeFileSystemSidebar');

        //Se la sorgente è stata aperta in creazione, non devo fare nulla
        if (!isValid(this.source.id)) {
            return;
        }
    },

    async beforeDestroy() {
        this.$root.$off("socketEventConnected");
        this.$root.$off("socketEventDisconnected");
        if (this.testResult.client != null) {
            this.disconnectServiceAccount(this.testResult.client.serviceAccount);
        }
    },
    methods: {
        disconnectServiceAccount,
        testServiceAccount,

        sendSATestResult(testResult) {
            this.testResult = testResult;
            this.source.id_service_account = testResult.serviceAccount.id;
        },

        setStep(nStep) {
            this.step = nStep;
            this.$root.$emit("closeFileSystemSidebar");
        },

        async toggleFileSystemSidebar() {
            if (this.testResult.client.serviceAccount.options.accountSessionId == "") {
                this.testResult.client.serviceAccount = (await this.testServiceAccount(this.testResult.client.serviceAccount)).serviceAccount
                if (this.testResult.client.serviceAccount == null) {
                    return;
                }
            }
            var config = FileSystemSidebarConfig.getForSource(
                this.$ONEServiceType.Network,
                this.testResult.client,
                this.testResult.client.serviceAccount.options.path,
            );

            this.$root.$emit(
                "toggleFileSystemSidebar",
                this.source.networkSource.paths,
                config
            );

        },



        saveSource() {
            let self = this;
            //I paths sono nodi ma devo salvare solamente la struttura {path:'', type:''}
            self.source.networkSource.paths = self.source.networkSource.paths.map(n => {
                return {
                    path: n.path,
                    type: n.type
                }
            });

            this.$root.$emit("saveBackupSource", this.source);
        }
    }
}
</script>
